<div class="flex flex-column gap">
    <p-card>
        <ng-template #header>
            <div class="card-header font-bold">
                <div class="flex-1 textSubheader large">{{ 'serviceType.settings.folderPersons.label' | translate }}</div>
            </div>
        </ng-template>
        <ng-template #content>
            <div class="grid-1col input-grid-gaps">
                <app-switch-input
                    id="multiPersonFolder"
                    [form]="form"
                    label="serviceType.settings.fields.multiPersonFolder"
                ></app-switch-input>

                <div class="font-size-x-small text-secondary">
                    {{ 'serviceType.settings.fields.multiPersonFolderHint' | translate }}
                </div>
            </div>
        </ng-template>
    </p-card>
</div>
